import IconProps from 'styled/components/Icon/Icon.types';
import StyledIcon from 'styled/components/Icon/Icon.styled';
import useMartyTheme from 'styled/hooks/useMartyTheme';

const Icon = ({ children, size = 'small', ...forwardProps }: IconProps) => {
  const { themed } = useMartyTheme();

  const elementSize = parseInt(String(themed(`global/icon/size/${size}`)));
  const viewboxSize = parseInt(String(themed(`global/icon/viewbox/${size}`)));

  return (
    <StyledIcon
      {...forwardProps}
      fill="none"
      height={elementSize}
      viewBox={`0 0 ${viewboxSize} ${viewboxSize}`}
      width={elementSize}
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </StyledIcon>
  );
};

export default Icon;
